module.exports = "/_next/static/videos/01-video-262fd3558f02d49f91a64a2576c22662.mp4";